import React, {
  useState,
  useEffect,
  useRef,
  useCallback
} from "react";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { useMount } from "../../../utils/genericCommon";
import Spinner from "../../../common/Spinner"; 
import NoDataAvailable from "../../../common/NoDataAvailable";
import ErrorComponent from "../../../common/ErrorComponent";
import UptimeAvailability from "../UptimeAvailability";
import DashletCircuitView from "../../overview/CircuitView"; 
import CircuitsTableView from "../circuitsTable";
import { getCircuitsData } from "../../circuits/common/masterTableUtil";
import { formatDate, shortDisplayDate24HourWithSec } from "../../../utils/displayTime";
import { health } from "../common/masterTableUtil";
import TrendAnalysis from "../UptimeAvailability/TrendAnalysis";
import css from "../circuitsMagneticStyle.less";
import apiService from "../../../config/api-config";   
import { getReportTimeFrame } from "../../../utils/common";
import { REPORT_NAMES } from "../../../utils/enums";
const [HbrCard] = reactWrapper(["hbr-card"]); 

const View = ({ 
  globalV4PayloadReport, 
  current_period_start,
  current_period_end, 
  siteNameSet 
 }) => {   
  const [tableLoaded, setTableLoaded] = useState(false); 
  const [bottomCircuitsLoaded, setBottomCircuitsLoaded] = useState(false);  
  const [circuitDataLoaded, setCircuitDataLoaded] = useState(false); 
  const [isSetAllSites, setAllSites] = useState(false); 
  const [selectedCircuits, setSelectedCircuits] = useState();  
  const [chartHeatMapData, setChartHeatMapData] = useState();  
  const [heatmapCircuitNames, setHeatmapCircuitNames] = useState();  
  const [chartHeatMapStatus, setChartHeatMapStatus] = useState();  
  const [errorMessage, setErrorMessage] = useState();  
  const reportTimeFrame = getReportTimeFrame(globalV4PayloadReport?.time_frame);
  const previewRef = useRef(null); 
  const mount = useMount();
  const [circuitsData, setCircuitsData] = useState({
    loader: true,
    error: null,
    data: [],
    availability: null,
    query: { timeFilterType: "" }
  }); 
  // get circuits data to set donut and circuits table
  const getAppData = useCallback(async query => { 
    const res = await getCircuitsData(query);
      if (mount.mounted) {
        if (!res.errorObject) {
          // create circuits data for summary, donut and table
          setCircuitsData({
            loader: false,
            error: null,
            data: res.data.data, 
            query
          });  
        }
        else {
          setCircuitsData({
            loader: false,
            error: res.errorObject,
            data: [],
            availability: null,
            query
          });
        }
        setCircuitDataLoaded(true);
      }
    }, []);

   // to set circuit table to true load in pdf  
  const isreportCallback = (data) => {
    setTableLoaded(data);
  };

  // to set bottom trend heatmap chart to true load in pdf
  const circuitsCallback = (data) => {
    setBottomCircuitsLoaded(data);
  };
  // set first 5 circuits names to send payload input to circuits availability api to get heatmap data   
  const selectedReportData = (circuitData) => {  
    let circuitsNames = []
    let circuitsPayloadNames = []
    if (circuitData && circuitData.length > 0) { 
      const selectedData =  circuitData.filter(item => item.health !== health.gray).slice(0, 5);
      setSelectedCircuits(selectedData); 
      selectedData.forEach(data => {
        circuitsNames.push(data.circuit_display_name);
        circuitsPayloadNames.push(data.circuit_name)
      }); 
      setHeatmapCircuitNames(circuitsNames);
      const reqPayload = {
        entry_ts: {
          start: shortDisplayDate24HourWithSec(formatDate(current_period_start).utc()),
          end: shortDisplayDate24HourWithSec(formatDate(current_period_end).utc())
        }, 
        circuit_name: [...circuitsPayloadNames],
        sort: { circuit_display_name: "asc", entry_ts: "asc" }
      };
       
      apiService.getTrendCircuitsAvailability(reqPayload).then(res => {
          if (!res.errorObject) {
            if (Array.isArray(res.data?.data)) {
              let circuitsList = res.data.data;
              for (const item of circuitsList) {
               const [, color] = item.circuit_name.split(":");
                item.circuit_name = `${item.host_name}:${color}`;
              }
            }  
            const trendHeatWidget= { isloading: false, resObj: {errorCode : '200', message:'successful'} };
            setChartHeatMapData(res.data); 
            setChartHeatMapStatus(trendHeatWidget); 
          }
          else { 
            setErrorMessage(res.errorObject);
          }
        }); 
    } 
  }  

  useEffect(() => {
    if ( 
        tableLoaded && circuitDataLoaded &&
        previewRef.current && bottomCircuitsLoaded &&
        (siteNameSet || isSetAllSites) ) {
      previewRef.current.id = "isLoaded_chart";
    }
  }, [ tableLoaded,  circuitDataLoaded ,siteNameSet, isSetAllSites, bottomCircuitsLoaded]);

  // When there's no circuit data, set bottomCircuitsLoaded to true so isLoaded_chart can be set
  // This prevents the ETL Lambda from timing out waiting for isLoaded_chart
  useEffect(() => {
    if (circuitDataLoaded && circuitsData.data?.length === 0) {
      setBottomCircuitsLoaded(true);
    }
  }, [circuitDataLoaded, circuitsData.data]);
  
  useEffect(() => {
    let payload = {
      ...globalV4PayloadReport,
      sort: {
        availability: "asc"
      } 
    }; 
    getAppData(payload);
    if(globalV4PayloadReport && globalV4PayloadReport["site_id"] == undefined){
      setAllSites(true);
    }
  }, []);
  return (
    <div className={`report-content ${css.reportlinkavailability}`} ref={previewRef}>
      <div className="hbr-css__layout-col-lg"> 
        <div className="linkAvailabilityMainHead">
          <HbrCard className="uptimeAvailability" container={true}>
            <UptimeAvailability reportData={circuitsData}/>
          </HbrCard> 
          <div className="circuitView">
              <DashletCircuitView  
                  reporting={true} 
                  reportName={'link_availability'} 
                  reportData={circuitsData}
                />
          </div>
       </div>
        <div>
        <HbrCard className="linkreportAvailReport" container={true}> 
          { selectedCircuits?.length > 0 && 
            heatmapCircuitNames?.length > 0  && 
            chartHeatMapStatus?.isloading === false
          ? ( 
            <TrendAnalysis 
                  reportHeatMapData={chartHeatMapData}
                  reportCircuitMasterTable={selectedCircuits}
                  reportSelectedTrendCircuits={heatmapCircuitNames}
                  reportChartHeatMapStatus={chartHeatMapStatus}
                  reportCurrentPeriodStart={current_period_start}
                  reportCurrentPeriodEnd={current_period_end}
                  circuitsCallback={circuitsCallback}
                  reportTimeFrame={reportTimeFrame} 
              /> 
          ) : (chartHeatMapData?.data?.length === 0 || 
            selectedCircuits?.length === 0 || 
            heatmapCircuitNames?.length === 0 ) ? (
              <div>
                <NoDataAvailable />
              </div>
          ) : (errorMessage) ? (
              <div>
                <ErrorComponent
                {...errorMessage}
                width="220px"
                className="large-dashlet-error"
                />
              </div>
          )
          : (
            <div className="avail-heatmap-loader">
             <Spinner />
            </div>
          )}
          </HbrCard> 
        </div>
        <CircuitsTableView
          globalV4PayloadReport={globalV4PayloadReport}
          reportName={REPORT_NAMES.REPORT_LINK_AVAILABILITY} 
          isreportCallback={isreportCallback}
          selectedReportData={selectedReportData}
        />
      </div>
    </div>
  );
};

View.propTypes = {
  globalV4PayloadReport: PropTypes.object.isRequired,
  current_period_start: PropTypes.any,
  current_period_end: PropTypes.any,
  siteNameSet: PropTypes.bool
};

export default View;
